import { render, staticRenderFns } from "./order-filter-tag.vue?vue&type=template&id=6cae4b1e&scoped=true&"
import script from "./order-filter-tag.component.ts?vue&type=script&lang=ts&"
export * from "./order-filter-tag.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-filter-tag.scss?vue&type=style&index=0&id=6cae4b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cae4b1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cae4b1e')) {
      api.createRecord('6cae4b1e', component.options)
    } else {
      api.reload('6cae4b1e', component.options)
    }
    module.hot.accept("./order-filter-tag.vue?vue&type=template&id=6cae4b1e&scoped=true&", function () {
      api.rerender('6cae4b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-v2/components/order-filter-tag/order-filter-tag.vue"
export default component.exports